<template>
  <div
    class="create-item_footer"
    :class="classes">
    <sButton
      v-show="mutableOptions.back.show"
      class="font-size-14 my-auto"
      :disabled="mutableOptions.back.disabled"
      type="text"
      @click="$emit('back-step')">
      <sIcon
        class="mr-3 my-auto"
        rotate="90"
        size="10"
        type="long-arrow"/>
      {{ mutableOptions.back.label }}
    </sButton>
    <TenderSteps
      v-if="mutableOptions.steps.show"
      :disabled="mutableOptions.steps.disabled"
      :loading="mutableOptions.steps.loading"
      :steps="mutableOptions.steps.items"
      :value="mutableOptions.currentStep"
      @update:value="$emit('click-step', $event)"/>
    <div
      v-show="isShowRightBlock"
      style="min-height: 40px;">
      <slot name="nextBefore"/>
      <sButton
        v-show="mutableOptions.next.show"
        class="my-auto"
        :disabled="mutableOptions.next.disabled"
        :loading="mutableOptions.next.loading"
        @click="$emit('next-step')">
        {{ mutableOptions.next.label }}
      </sButton>
    </div>
  </div>
</template>
<script>
import { componentOptions} from 'mixins'

export default {
  name: 'CreateItemFooter',
  mixins: [ componentOptions],
  data() {
    return {
      mutableOptions: {
        currentStep: 1,
        back: {
          show: true,
          disabled: false,
          label: this.$t('Common.Back'),
        },
        steps: {
          show: false,
          items: null, // {label: String, hint: String}
          disabled: false,
          loading: false,
        },
        next: {
          show: true,
          disabled: false,
          loading: false,
          label: this.$t('Common.Next'),
        },
      },
    }
  },
  computed: {
    isShowRightBlock() {
      return this.mutableOptions.next.show || this.mutableOptions.steps.show
    },
    classes() {
      const countShow = [this.mutableOptions.back.show, this.mutableOptions.steps.show, this.isShowRightBlock].filter(v => v).length
      return {
        'is-full': countShow === 3,
        'is-medium': countShow === 2,
        'is-small': countShow === 1,
      }
    },
  },
}
</script>
<style scoped lang="scss">
.create-item {
  &_footer {
    position: sticky;
    bottom: 0;
    z-index: 10;
    background: var(--v-main__green-base);
    display: grid;
    gap: 5px;
    padding: 15px;
    border-top: 2px solid #D8F1F0;
    &.is-full {
      grid-template-columns: auto 1fr auto;
    }
    &.is-medium {
      grid-template-columns: auto auto;
      justify-content: space-between;
    }
    &.is-small {
      grid-template-columns: auto;
      justify-content: end;
    }
  }
}
</style>